import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from "react";
import { Radio } from "@jti/ui/components/Radio";
import styles from "../ConsentBlock.module.scss";
export const ConsentRadioInput = ({ value, label }) => {
    const id = useId();
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: styles.radioInput, children: _jsx(Radio, { value: value, id: id }) }), _jsx("label", { className: styles.radioInputLabel, htmlFor: id, children: label })] }));
};
//# sourceMappingURL=ConsentRadioInput.js.map